import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DEFAULT_ROUTER_FEATURENAME, getSelectors as getRouterStoreSelectors, RouterReducerState } from '@ngrx/router-store';

const getRouterState = createFeatureSelector<RouterReducerState>(DEFAULT_ROUTER_FEATURENAME);
export const routerSelectors = getRouterStoreSelectors(getRouterState);
export const fragmentFromUrl = createSelector(routerSelectors.selectUrl, (url) => unescape(url).split('#')[1]);
